import { Show } from "solid-js";
import { useModal } from "~/components/modal";
import { ViewOfferDetails } from "~/components/webstore/view_offer_details";
import { OfferConstruct } from "~/server/types/brand";

export function DividerWithOfferConstruct(props: {
  offerConstruct?: OfferConstruct;
  dividerClass?: string;
}) {
  const { openModal } = useModal()!;
  return (
    <div
      class={`flex w-full ${props.dividerClass} items-center justify-center gap-4`}
    >
      <Show when={props.offerConstruct?.type === "SUBSCRIPTION_REWARD"}>
        <Show
          when={props.offerConstruct?.subscriptionRewardDetails.length === 1}
        >
          <div class="flex items-center justify-center gap-3">
            <p class="flex h-6 items-center justify-center text-nowrap rounded-lg bg-[#1A4E33] px-2 text-[11px] font-semibold leading-[140%] tracking-[-0.11px] text-[#24DD7D]">
              {props.offerConstruct?.subscriptionRewardDetails[0]?.tenure}{" "}
              months offer
            </p>
            <div class="h-px w-full darkTheme:bg-baseTertiaryDark dark:bg-basePrimaryMedium">
              &nbsp;
            </div>
          </div>
        </Show>
        <Show
          when={
            (props.offerConstruct?.subscriptionRewardDetails?.length ?? 0) > 1
          }
        >
          <p class="text-nowrap text-mediumSemiBold text-white">Choose offer</p>
        </Show>
      </Show>
      <div class="h-px w-full bg-[#E5E5E5] darkTheme:bg-baseTertiaryDark dark:bg-basePrimaryMedium">
        &nbsp;
      </div>
      <Show when={props.offerConstruct}>
        <button
          onClick={() => {
            openModal(
              () => <ViewOfferDetails offerConstruct={props.offerConstruct} />,
              "md:!min-w-[566px] overflow-hidden !max-w-[566px] !p-0",
              "w-[566px] overflow-hidden"
            );
          }}
          class="cursor-pointer text-nowrap text-[10px] font-semibold leading-[140%] tracking-[-0.1px] text-white underline [text-underline-position:from-font]"
        >
          OFFER DETAILS
        </button>
      </Show>
    </div>
  );
}
